export default __webpack_public_path__ + "static/media/up-circle-o.12b85e2e.svg";